import Dialog from '../../dialog/Dialog';
import strings from '../../../translations';
import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { useAppSelector } from '../../../state/hooks';

import { setFeatureFilterPayload, setFilteredFeatureResults } from '../../../state/slices/rpcSlice';
import {
  setIsFilteredFeatureResultsOpen,
  setMaximizeFilteredFeatureResults,
  setMinimizeFilteredFeatureResults
} from '../../../state/slices/uiSlice';
import FilteredFeatureResults from '../FilteredFeatureResults';

const FilteredFeatureDataDialog = () => {
  const { store } = useContext(ReactReduxContext);
  const maximizeFilteredFeatureResults = useAppSelector(
    (state) => state.ui.maximizeFilteredFeatureResults
  );
  const minimizeFilteredFeatureResults = useAppSelector(
    (state) => state.ui.minimizeFilteredFeatureResults
  );
  const isFilteredFeatureResultsOpen = useAppSelector(
    (state) => state.ui.isFilteredFeatureResultsOpen
  );
  const actionKey = useAppSelector((state) => state.rpc.actionKey);

  const handleCloseGFIDialog = () => {
    store.dispatch(setIsFilteredFeatureResultsOpen(false));
    store.dispatch(setFeatureFilterPayload(null));
    store.dispatch(setFilteredFeatureResults([]));
    if (minimizeFilteredFeatureResults) store.dispatch(setMinimizeFilteredFeatureResults(false));
  };

  return isFilteredFeatureResultsOpen ? (
    <Dialog
      drag={true} /* Enable (true) or disable (false) drag */
      resize={true}
      fullScreenOnMobile={
        true
      } /* Scale dialog full width / height when using mobile device */
      title={actionKey} /* Dialog header title */
      type={'gfi'} /* Dialog type */
      closeAction={
        handleCloseGFIDialog
      } /* Action when pressing dialog close button or backdrop */
      id="filtered_gfi_dialog"
      minWidth={'25rem'}
      minHeight={'25rem'}
      height={'35rem'}
      width={'35rem'}
      maximizable={true}
      minimizable={true}
      maximize={maximizeFilteredFeatureResults}
      minimize={minimizeFilteredFeatureResults}
      maximizeAction={() =>
        store.dispatch(
          setMaximizeFilteredFeatureResults(!maximizeFilteredFeatureResults)
        )
      }
      minimizeAction={() =>
        store.dispatch(
          setMinimizeFilteredFeatureResults(!minimizeFilteredFeatureResults)
        )
      }
      maxWidth={maximizeFilteredFeatureResults ? null : '90vw'}
      maxHeight={maximizeFilteredFeatureResults ? null : '90vh'}
      anchorX="center"
      anchorY="center"
      anchorOriginX="55%"
      anchorOriginY="50%"
    >
      <FilteredFeatureResults />
    </Dialog>
  ) : null;
};

export default FilteredFeatureDataDialog;
